import ManageSearchIcon from '@mui/icons-material/ManageSearch'
import InfoPanel from '@rentspree/component-2023.components.organisms.info-panel'

import styles from './index.module.scss'

export const ReviewModePanel = () => (
  <InfoPanel
    title="Review mode"
    severity="warning"
    customIcon={<ManageSearchIcon />}
    className={styles.reviewModePanelContainer}
  >
    This listing is only visible to administrators. Please review all details and approve to make it
    live for public viewing.
  </InfoPanel>
)
